import { Box, Grid } from "@mui/material"
import { NoDataFound } from "../../../empty/Index"

export const Tbody = ({salesBranchList, generateForm}) => {
    return (
        <Box height="100%" width="100%" bgcolor="#FFFFFF" borderRadius="12px" className="overflowY" display="flex" flexDirection="column" gap="12px" p={2}>
            {(!generateForm.infiniteLoad && salesBranchList.length === 0) && <NoDataFound/>}
            {(!generateForm.infiniteLoad && salesBranchList.length > 0) && salesBranchList.map((v,k) => (
                <Grid key={k} container direction="row" sx={{p:2, border:'1px solid #EBEBEB', borderRadius:'10px'}}>
                    <Grid item xs={2}>{v.name}</Grid>
                    <Grid item xs={2}>{v.first_name} {v.last_name}</Grid>
                    <Grid item xs={2} textAlign="center">{v.date}</Grid>
                    <Grid item xs={2} textAlign="center">
                        {v.total_sales == null
                            ? "-"
                            : `₱ ${parseFloat(v.total_sales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </Grid>
                    <Grid item xs={2} textAlign="center">
                        {v.adjusted_total_sales == null
                            ? "-"
                            : `₱ ${parseFloat(v.adjusted_total_sales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </Grid>
                    <Grid item xs={1} textAlign="center">
                        {v.actual_sales == null
                            ? "-"
                            : `₱ ${parseFloat(v.actual_sales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </Grid>
                    <Grid item xs={1} textAlign="center">
                        {v.variance == null
                            ? "-"
                            : `₱ ${parseFloat(v.variance).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </Grid>
                </Grid>
            ))}
        </Box>
    )
}